export enum EUserOtcQueryKey {
  GET_OTC_PRICE = 'get-otc-price',
  GET_OTC_HISTORY = 'get-otc-history',
  OTC_PAY_ORDER = 'otc-pay-order',
  OTC_PLACE_ORDER = 'otc-place-order',
  OTC_PLACE_CONVERT_ORDER = 'otc-place-convert-order',
  OTC_FINALIZE_CONVERT_ORDER = 'otc-finalize-convert-order',
}
